import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="avatar-upload"
export default class extends Controller {
  static targets = ["fileInput", "dropZone", "uploadArea", "previewArea", "previewImage", "fileName", "errorArea", "errorMessage", "removeFlag", "removeButton"]

  connect() {
    this.maxSize = 5 * 1024 * 1024 // 5MB in bytes
    this.allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']
  }

  triggerFileSelect(event) {
    event.preventDefault()
    this.fileInputTarget.click()
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.processFile(file)
    }
  }

  handleDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'copy'
    this.dropZoneTarget.classList.add('border-primary-400', 'bg-primary-50')
  }

  handleDragLeave(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove('border-primary-400', 'bg-primary-50')
  }

  handleDrop(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove('border-primary-400', 'bg-primary-50')
    
    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.processFile(files[0])
    }
  }

  processFile(file) {
    // Clear any previous errors
    this.hideError()

    // Validate file type
    if (!this.allowedTypes.includes(file.type)) {
      this.showError('Please select a valid image file (JPEG, PNG, or WebP)')
      return
    }

    // Validate file size
    if (file.size > this.maxSize) {
      this.showError('File size must be less than 5MB')
      return
    }

    // Create preview
    this.createPreview(file)
    
    // Update file input (this will be submitted with the form)
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.fileInputTarget.files = dataTransfer.files
  }

  createPreview(file) {
    const reader = new FileReader()
    
    reader.onload = (e) => {
      this.previewImageTarget.src = e.target.result
      this.fileNameTarget.textContent = file.name
      
      // Show preview, hide upload area
      this.uploadAreaTarget.classList.add('hidden')
      this.previewAreaTarget.classList.remove('hidden')
    }
    
    reader.readAsDataURL(file)
  }

  removeFile(event) {
    event.preventDefault()
    
    // Clear file input
    this.fileInputTarget.value = ''
    
    // Show upload area, hide preview
    this.previewAreaTarget.classList.add('hidden')
    this.uploadAreaTarget.classList.remove('hidden')
    
    // Clear any errors
    this.hideError()
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.errorAreaTarget.classList.remove('hidden')
  }

  hideError() {
    this.errorAreaTarget.classList.add('hidden')
    this.errorMessageTarget.textContent = ''
  }

  markForRemoval(event) {
    event.preventDefault()
    
    if (confirm('Remove your current profile photo?')) {
      
      // Mark avatar for removal
      if (this.hasRemoveFlagTarget) {
        this.removeFlagTarget.value = 'true'
      } 
      
      // Update button appearance
      if (this.hasRemoveButtonTarget) {
        this.removeButtonTarget.innerHTML = '<span>Will be removed on save</span>'
        this.removeButtonTarget.disabled = true
        this.removeButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
        this.removeButtonTarget.classList.remove('hover:text-red-500')
      } 
    }
  }
}